import React from 'react';

import styles from '../../../PrimaryNavigation.module.scss';
import {
  Avatar,
  MenuHeader,
  MenuItem,
  MenuSection,
  MenuSeparator,
  MenuCollection,
  Text,
} from 'components/core';
import { Organization } from 'components/shared/PrimaryNavigation/PrimaryNavigation';
import { Inline } from 'components/layout';

interface Props {
  organizations: Organization[];
  className?: string;
}

const OrganizationSection = ({ organizations }: Props) => {
  if (!organizations?.length) {
    return null;
  }

  return (
    <MenuSection>
      <MenuHeader>
        <Text
          size="xs"
          variant="weak"
          className={styles.PrimaryNavigation_paddingMenu}
        >
          Organizations
        </Text>
      </MenuHeader>
      <MenuCollection items={organizations}>
        {(item) => {
          if (item.isAdmin) {
            return (
              <MenuItem
                key={item.id}
                href={`/organizations/${item.id}/overview`}
              >
                <Inline alignX="left" spacing={2}>
                  <Avatar name={item.name} size="xs" aria-hidden />
                  {item.name}
                </Inline>
              </MenuItem>
            );
          }

          return (
            <MenuItem key={item.id}>
              <Inline alignX="left" spacing={2}>
                <Avatar name={item.name} size="xs" aria-hidden />
                {item.name}
              </Inline>
            </MenuItem>
          );
        }}
      </MenuCollection>
      <MenuSeparator />
    </MenuSection>
  );
};

export default OrganizationSection;
